import React from 'react';
import HomePageCard from '@/features/homePage/components/HomePageCard';
import SmartPhone from '../../features/homePage/svgs/SmartPhone';
import Shield from '../../features/homePage/svgs/Shield';
import Timer from '../../features/homePage/svgs/Timer';
import HeartService from '../../features/homePage/svgs/HeartService';
import TickDouble04 from '../svgs/TickDouble04';
import SaveMoneyDollar from '../svgs/SaveMoneyDollar';
import Taxes from '../svgs/Taxes';
import CheckmarkBadge04 from '../svgs/CheckmarkBadge04';
import Calculator from '@/features/homePage/svgs/Calculator';
import MessageDone from '../svgs/MessageDone';
import DocumentAttachment from '../svgs/DocumentAttachment';
import ValidationApproval from '../svgs/ValidationApproval';

const reasonsIcons = {
  "checkmark-badge-04": <CheckmarkBadge04 />,
  "tick-double-04": <TickDouble04 />,
  "timer-02": <Timer />,
  "service": <HeartService />,
  "save-money-dollar": <SaveMoneyDollar />,
  "taxes": <Taxes />,
  "smart-phone-04": <SmartPhone />,
  "shield": <Shield />,
  "heart-service": <HeartService />,
  "calculator-01":<Calculator/>,
  "message-done-02":<MessageDone/>,
  "document-attachment": <DocumentAttachment />,
  "validation-approval":<ValidationApproval />
}

const resolveReasonIcon = (icon) => {
  if (typeof icon === 'string') {
    return reasonsIcons[icon] || null
  }

  return icon || null
}

const formatReasonCardTitle = (title) => {
  if (!title || typeof title !== 'string') {
    return title || ''
  }

  if (title !== title.toUpperCase()) {
    return title
  }

  return title
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const normalizedWord = word.trim()

      if (!normalizedWord) {
        return normalizedWord
      }

      if (/^[A-Z0-9.]+$/.test(normalizedWord) && normalizedWord.length <= 5) {
        return normalizedWord
      }

      return normalizedWord.toLowerCase()
    })
    .join(' ')
}

const defaultReasons = [
  {
    title: "100% Online",
    description: "Fai tutto dal divano col tuo smartphone. Addio permessi a lavoro e sale d'attesa.",
    icon: <SmartPhone />
  },
  {
    title: "Zero Intermediari",
    description: "Non esternalizziamo nulla. Le tue pratiche sono lavorate solo dal nostro team interno, per garantirti massima privacy e zero ritardi.",
    icon: <Shield />
  },
  {
    title: "Velocità Record",
    description: "Elaboriamo la maggior parte delle pratiche in sole 24/48 ore lavorative.",
    icon: <Timer />
  },
  {
    title: "Assistenza Umana",
    description: "Nessun bot. Esperti fiscali veri pronti ad aiutarti in chat o al telefono.",
    icon: <HeartService />
  }
];

const WhyUs = ({ bgclass = 'bg-[#8fc0450d]', reasons = defaultReasons }) => {
  const normalizedReasons = Array.isArray(reasons)
    ? reasons
    : defaultReasons


  return (
    <>
      {normalizedReasons.length > 0 && <div className={`${bgclass} flex flex-col gap-[24px] md:gap-[40px] items-center justify-center px-[16px] md:px-[64px] py-[24px] md:py-[80px] relative w-full h-full`}>
        <h2 className="font-bold leading-[40px] m-0 relative shrink-0 text-[#262f39] text-[24px] md:text-[32px] text-center w-full">
          Perché <span className="text-[#8fc045]">sceglierci</span>
        </h2>
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-[16px] xl:gap-[32px] items-stretch relative shrink-0 w-full">
          {normalizedReasons.map((reason, index) => (
            <div key={index} className="flex w-full">
              <HomePageCard
                title={formatReasonCardTitle(reason.title)}
                description={reason.description}
                icon={resolveReasonIcon(reason.icon)}
                className="bg-[#8fc0450d] border-[#8fc0450d] p-[20px] border-4"
                iconWrapperClass="bg-[#8fc04533] border-transparent"
                iconWrapperSizeClass="w-[72px] h-[72px]"
                iconSizeClass="w-[40px] h-[40px]"
                titleClass="text-[16px] md:text-[18px] leading-[24px]"
                descClass="text-[#6d6d6d] text-[14px] md:text-[16px] leading-[20px] md:leading-[22px]"
              />
            </div>
          ))}
        </div>
      </div>}
    </>
  );
};

export default WhyUs;